
import { getAccessibility } from "../utils/host"
// added script to enable accessibility mode according to client preference
export const activteAccessibililty = async (realm) => {
    let isAccessibilityModeEnabled = false
    try {
        //fetch isAccessibilityModeEnabled from local storage to check if accessibility mode is enabled or not
        let result = (await getAccessibility(realm)).data

        isAccessibilityModeEnabled = result.isAccessibilityModeEnabled

        if (isAccessibilityModeEnabled) {
            console.log("isAccessibilityModeEnabled is enabled and executing script")
            const script = document.createElement('script');
            script.textContent = ` (function(){
            var s    = document.createElement('script');
            var h    = document.querySelector('head') || document.body;
            s.src    = 'https://acsbapp.com/apps/app/dist/js/app.js';
            s.async  = true;
            s.onload = function(){
                acsbJS.init({
                    statementLink    : '',
                    footerHtml       : '',
                    hideMobile       : false,
                    hideTrigger      : false,
                    disableBgProcess : false,
                    language         : 'en',
                    position         : 'right',
                    leadColor        : '#146FF8',
                    triggerColor     : '#146FF8',
                    triggerRadius    : '50%',
                    triggerPositionX : 'right',
                    triggerPositionY : 'bottom',
                    triggerIcon      : 'people',
                    triggerSize      : 'bottom',
                    triggerOffsetX   : 5,
                    triggerOffsetY   : 5,
                    mobile           : {
                        triggerSize      : 'small',
                        triggerPositionX : 'right',
                        triggerPositionY : 'bottom',
                        triggerOffsetX   : 10,
                        triggerOffsetY   : 10,
                        triggerRadius    : '20'
                    }
                });
            };
            h.appendChild(s);
         })()`;
            document.body.appendChild(script);
        }
    } catch (error) {
        console.log("error in script", error)
    }
}